import { render, staticRenderFns } from "./QnAListP.vue?vue&type=template&id=68c10cd2&"
import script from "./QnAListP.vue?vue&type=script&lang=js&"
export * from "./QnAListP.vue?vue&type=script&lang=js&"
import style0 from "./QnAListP.vue?vue&type=style&index=0&id=68c10cd2&prod&lang=scss&"
import style1 from "./QnAListP.vue?vue&type=style&index=1&id=68c10cd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports